// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "sentry" + "." + "1e2dd6bd6be23a5df511" + ".bundle.js";
};